import {SmartComponent} from "smart-component-js";

class ConversationalToolCardComponent extends SmartComponent {

    constructor(element, parentComponent, params) {
        super(element, parentComponent, params);
        this.element = element;
        this.area = this.element.dataset.area || 'privati';
        this.init();
    }


    appendOptions(options = '') {

        const wrapper = this.element.querySelector('.conversational-tool-card__options');
        if (typeof options === 'string') {
            wrapper.innerHTML = options;
        } else if (Array.isArray(options)) {
            let html = '';
            options.forEach((option, index) => html += this.getOptionHtml(option, index));
            wrapper.innerHTML = html;
        }
        this.element.classList.remove('absolute-loading');
    }

    getOptionHtml(option, index) {
        return `
            <a class="conversational-tool-card__item" href="${GENERIC_TRANSLATION.toolConversazionaleLink}?area=${this.area}&id=${index}">
                ${option.icon ? `<img src="${option.icon}" alt="${option.label}">` : ''}
                <span>${option.label}</span>
            </a>
        `;
    }

    init() {
        this.element.classList.add('absolute-loading');
        youserxp.ajax(`/api/1.0/hdi-assicurazioni/conversation/${this.area}`, {
            method: 'GET',
            auth: true
        }).then(
            (obj) => this.appendOptions(obj.body.question?.answers),
            () => this.element.classList.remove('absolute-loading')
        );
    }
}

export default ConversationalToolCardComponent;